import * as React from "react";
import appstate from "../../appstate";
import {toJS} from "mobx";
import {observer} from 'mobx-react';
import {LoadingPage} from "../shared/loadingPage";
import "./AffiliateHotels.scss";

export interface IAffiliateHotelsProps {
    startDate: string,
    endDate: string,
    guestCount: CC.Library.Models.Calendar.NcbCalendarRoom[],
    firstAvailableDate?: string,
    selectFirstAvailableDateCallback: (startDate: string) => void
}

export interface IAffiliateHotelsState {
    roomAvailableWithoutCode: boolean
}

interface IAffiliateAvailabilityResult {
    affiliateId: string,
    isLoading: boolean,
    isAvailable: boolean,
    price: number,
    currency: string,
    isSynxisHotel: boolean,
    isHostHotel: boolean
}

@observer
export class AffiliateHotels extends React.Component<IAffiliateHotelsProps, IAffiliateHotelsState> {
    
    affiliateHotels = NCB.Settings.FeatureMatrixConfiguration.AlternativeHotels.filter(x => x.IsActive);
    affiliateAvailability: IAffiliateAvailabilityResult[] = [];
    queryString: string;

    constructor(props: IAffiliateHotelsProps) {
        super(props);

        this.props = props;

        this.state = {
            roomAvailableWithoutCode: false
        };

        this.queryString = this.createQuery();

        if (NCB.AlternativeHotels.hasAlternativeHotels()) {
            if (appstate.useAlternativeHotel) {
                this.loadAvailability();
            } else {
                // The URL contains a direct link to Rate or promotion code
                // In this case we must check if there are any public rates available for this date
                let i = this.affiliateHotels.push({
                    Id: NCB.Utils.GUID(),
                    HotelId: NCB.Settings.HotelId,
                    ChainId: NCB.Settings.ChainId,
                    HotelName: null,
                    IsActive: true,
                    BookingUrl: null
                });
    
                let x  = this.affiliateHotels[i-1];
    
                this.affiliateAvailability.push({
                    affiliateId: x.Id,
                    isLoading: true,
                    isAvailable: false,
                    price: -1,
                    currency: NCB.Settings.Currency,
                    isSynxisHotel: true,
                    isHostHotel: true
                });
    
                this.findAffiliateAvailability(x.Id, x.ChainId, x.HotelId);
            }
        }        
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentWillReceiveProps(nextProps: IAffiliateHotelsProps) {
    }

    loadAvailability = () => {
        this.affiliateHotels.filter(x => x.HotelId != NCB.Settings.HotelId).forEach(x => {
            let isSynxisHotel = x.ChainId.length > 0 && x.HotelId.length > 0;
            this.affiliateAvailability.push({
                affiliateId: x.Id,
                isLoading: isSynxisHotel,
                isAvailable: false,
                price: -1,
                currency: NCB.Settings.Currency,
                isSynxisHotel: isSynxisHotel,
                isHostHotel: false
            })
            this.findAffiliateAvailability(x.Id, x.ChainId, x.HotelId);
        });
    }

    createQuery = () => {
        let q = ["showCalendar=true", 'startDate=' + this.props.startDate, 'endDate=' + this.props.endDate];
        let hasChildren = false;

        this.props.guestCount.forEach(g => {
            let adults = NCB.Utils.getNumAdults(g.Guests);
            let children = NCB.Utils.getNumChildren(g.Guests)
            if (children > 0)
                hasChildren = true;
            q.push("room=" + adults + "_" + children);
        });

        if (hasChildren) {
            this.props.guestCount.forEach(g => {
                let ages = g.Guests.filter(x => x.GuestType === CC.Library.Models.Shared.GuestType.Child && x.Count > 0).map(x => "" + x.Age);
            
                q.push("ages=" + ages.join('_'));
            });
        }

        return '?' + q.join('&');
    }

    findAffiliateAvailability = (affiliateId: string, chainId: string, hotelId: string) => {
        let affiliate = this.affiliateAvailability.filter(x => x.affiliateId === affiliateId)[0];
        if (affiliate == null)
            return;

        // Is this a SynXis hotel?
        if (chainId.length < 1 || hotelId.length < 1) {
            affiliate.isAvailable = true;
            return;
        }

        let req = NCB.Availability.generateDefaultRequest();
        req.ChainId = chainId;
        req.HotelCode = hotelId;
        req.StartDate = this.props.startDate;
        req.EndDate = this.props.endDate;
        req.Guests = [
            {
                GuestType: CC.Library.Models.Shared.GuestType.Adult,
                Count: 1,
                Age: null
            }
        ];

        NCB.Availability.getAvailability({
            success: (res: CC.Library.Models.Availability.AvailabilityResponse) => {

                if (res.Success && res.Rooms != null && res.Rooms.length > 0) {

                    let foundCurrency = "";
                    let foundPrice = -1;
                    res.Rooms.forEach(x => {
                        foundCurrency = x.Price.CurrencyCode;
                        if (foundPrice === -1 || foundPrice > x.Price.AmountAfterTax)
                            foundPrice = x.Price.AmountAfterTax;
                    });

                    affiliate.isAvailable = true;
                    affiliate.price = foundPrice;
                    affiliate.currency = foundCurrency;
                } else {
                    affiliate.isAvailable = false;
                }

                affiliate.isLoading = false;

                if (affiliate.isHostHotel) {
                    if (affiliate.isAvailable) {
                        this.setState({ roomAvailableWithoutCode: true })
                    } else {
                        if (appstate.useAlternativeHotel)
                            this.loadAvailability();
                        else
                            this.forceUpdate();
                    }
                } else {
                    this.forceUpdate();
                }
            },
            error: (error: NCB.Proxy.ICompoundError) => {
                affiliate.isLoading = false;
                affiliate.isAvailable = false;
                console.log("AffiliateHotels: Error loading rooms ", error);

                this.forceUpdate();
            }
        }, req);

    }

    render() { 

        if (this.affiliateAvailability.some(x => x.isHostHotel && x.isLoading)) {
            return <div className="ncb-affiliate-wrapper"><LoadingPage headline="" message="" /></div>;
        }

        let affiliateHotels: JSX.Element[] = [];

        this.affiliateAvailability.filter(x => !x.isHostHotel).forEach(x => {
            let hotel = this.affiliateHotels.filter(ah => ah.Id === x.affiliateId)[0];
            if (hotel == null)
                return null;

            let url = x.isSynxisHotel ? NCB.FeatureMatrix.translate(hotel.BookingUrl) + this.queryString : NCB.FeatureMatrix.translate(hotel.BookingUrl);

            affiliateHotels.push(<div className="ncb-affiliate-link" data-is-loading={x.isLoading} data-is-available={x.isAvailable} data-price={x.price}>
                <a className="ncb-button" href={url} target="_BLANK">
                    {NCB.FeatureMatrix.translate(hotel.HotelName)} <span className="ncb-affiliate-link-price">fr. {x.price} {x.currency}</span> <span className="ncb-affiliate-link-unavailable-text"> – {NCB.I18n.T.AFFILIATE_NO_ROOMS_AVAILABLE}</span>
                </a>
            </div>);
        });

        let actionButton: JSX.Element;
        let actionButtonSecondary: JSX.Element;

        // Secondary action

        let urlRate = NCB.Utils.getParameterFromURL("rate");
        let urlPromotion = NCB.Utils.getParameterFromURL("promotionCode");
        let isFilteredFromURL = (urlRate != null && urlRate.length > 0) || (urlPromotion != null && urlPromotion.length > 0);

        // Primary action
        if (this.state.roomAvailableWithoutCode) {
            // "Se andra erbjudanden på detta datum"
            actionButton = <button className="ncb-button" onClick={(e:any) => {e.preventDefault(); document.location.href=appstate.getLinkForCart(""); }}>{NCB.I18n.T.SEE_ALL_AVAILABLE_ROOMS_FOR_THIS_DATE}</button>
            
            //  "Välj ett annat datum med samma erbjudande"
            actionButtonSecondary = <button className="ncb-button" onClick={(e:any) => {e.preventDefault(); document.location.href=appstate.getLinkForCart(null, NCB.Utils.getParameterFromURL("rate"), "", ""); }}>
                {NCB.I18n.T.CHOOSE_ANOTHER_DATE_WITH_THE_SAME_OFFER}
            </button>;
            
        } else if (this.props.firstAvailableDate == null) {
            // "Välj ett nytt datum"
            //actionButton = <button className="ncb-button" onClick={(e:any) => {e.preventDefault(); this.props.selectFirstAvailableDateCallback(null)}}>{NCB.I18n.T.CHOOSE_ANOTHER_DATE_WITH_THE_SAME_OFFER}</button>

            // "Se andra erbjudanden på detta datum"
            //actionButton = <button className="ncb-button" onClick={(e:any) => {e.preventDefault(); document.location.href=appstate.getLinkForCart(""); }}>{NCB.I18n.T.SEE_ALL_AVAILABLE_ROOMS_FOR_THIS_DATE}</button>
            if (isFilteredFromURL) {
                //  "Välj ett annat datum med samma erbjudande"
                actionButtonSecondary = <button className="ncb-button" onClick={(e:any) => {e.preventDefault(); document.location.href=appstate.getLinkForCart(null, NCB.Utils.getParameterFromURL("rate"), "", ""); }}>
                    {NCB.I18n.T.CHOOSE_ANOTHER_DATE_WITH_THE_SAME_OFFER}
                </button>;
            } else {
                // "Första tillgänliga datum: yyyy-mm-dd"
                actionButton = <button className="ncb-button" onClick={(e:any) => {e.preventDefault(); this.props.selectFirstAvailableDateCallback(this.props.firstAvailableDate)}}>{NCB.I18n.T.SELECT_A_NEW_DATE}</button>;
            }
        } else {
            // "Första tillgänliga datum: yyyy-mm-dd"
            let humaneDate = NCB.DateUtils.getHumaneDate(new Date(Date.parse(this.props.firstAvailableDate)), true);
            actionButton = <button className="ncb-button" onClick={(e:any) => {e.preventDefault(); this.props.selectFirstAvailableDateCallback(this.props.firstAvailableDate)}}>{NCB.I18n.T.AFFILIATE_FIRST_AVAILABLE_DATE}: {humaneDate}</button>;
        }


        
        let dateRange = NCB.DateUtils.getHumaneDateRange(new Date(Date.parse(this.props.startDate)), new Date(Date.parse(this.props.endDate)));

        return <div className="ncb-affiliate-wrapper">
            <div className="ncb-affiliate-headline"><h2>{NCB.I18n.T.AFFILIATE_NO_ROOM_AVAILABLE_HEADLINE} {dateRange}</h2></div>

            <div className="ncb-affiliate-first-available-date">
                <div className="ncb-affiliate-first-available-date-options">
                    {actionButton}
                    {actionButtonSecondary}
                </div>
            </div>

            <div className="ncb-affiliate-links" style={{display: this.affiliateHotels.length > 0 && this.affiliateAvailability.filter(x => !x.isHostHotel).some(x => x.isAvailable) ? "block" : "none"}}>
                <div className="ncb-affiliate-links-headline">
                    <h2>{NCB.I18n.T.AFFILIATE_BOOK_ROOM_HEADLINE}</h2>
                </div>

                <div className="ncb-affiliate-links-list">
                    {
                        affiliateHotels
                    }
                </div>
            </div>
        </div>
    }
}




// WEBPACK FOOTER //
// ./src/components/wizard/affiliateHotels.tsx